(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-mobile-drawer');
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onlyMobile = this.dataset?.onlyMobile === 'true';

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;

      const annBar = document.querySelector('.section-announcement');
      const annBarHeight = annBar?.getBoundingClientRect().height || 0;

      this.headerCoords.bottom = pageYOffset + clientRect.bottom + annBarHeight;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      if (this.onlyMobile && window.innerWidth >= 1160) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSettings();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeSettings() {
      const settingsModal = this.header.querySelector(
        '.header-elements-group--icons .js-settings-trigger + .header-settings--visible'
      );
      if (settingsModal) {
        settingsModal.classList.remove('header-settings--visible');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
(function () {
  'use strict';

  var STORAGE_KEY = 'dme_countdown_target';
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

  function resolveTarget(dateStr) {
    if (dateStr && dateStr.trim() !== '') {
      var parsed = new Date(dateStr + 'T00:00:00').getTime();
      if (!isNaN(parsed)) return parsed;
    }
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var n = parseInt(stored, 10);
        if (!isNaN(n) && n > Date.now()) return n;
      }
      var fresh = Date.now() + THIRTY_DAYS_MS;
      localStorage.setItem(STORAGE_KEY, fresh.toString());
      return fresh;
    } catch (e) {
      return Date.now() + THIRTY_DAYS_MS;
    }
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init() {
    var el = document.getElementById('PasswordCountdown');
    if (!el) return;

    var target = resolveTarget(el.getAttribute('data-target') || '');

    var els = {
      days:    document.getElementById('CountdownDays'),
      hours:   document.getElementById('CountdownHours'),
      minutes: document.getElementById('CountdownMinutes'),
      seconds: document.getElementById('CountdownSeconds')
    };

    if (!els.days || !els.hours || !els.minutes || !els.seconds) return;

    var intervalId;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        els.days.textContent = els.hours.textContent = els.minutes.textContent = els.seconds.textContent = '00';
        clearInterval(intervalId);
        return;
      }
      els.days.textContent    = pad(Math.floor(diff / 86400000));
      els.hours.textContent   = pad(Math.floor((diff % 86400000) / 3600000));
      els.minutes.textContent = pad(Math.floor((diff % 3600000) / 60000));
      els.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    intervalId = setInterval(tick, 1000);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearInterval(intervalId);
      } else {
        tick();
        intervalId = setInterval(tick, 1000);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

  } catch(e) { console.error(e); }
})();
})();
